const hostApi = process.env.VUE_APP_API_URL;
const baseURLApi = `${hostApi}/api`;
const defaultLanguage = "de";
const defaultCountry = "de";

export default {
    baseURLApi,
    defaultLanguage,
    defaultCountry
}
